<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid
      .column.is-widescreen-5.is-desktop-6
        .u-mb-mi
          AppImg(:srcset="[{ srcset: '{CDN_URL}/ventures/sellesa@2x.webp 2x, {CDN_URL}/ventures/sellesa.webp 1x', type: 'image/webp' },  { srcset: '{CDN_URL}/ventures/sellesa@2x.png 2x, {CDN_URL}/ventures/sellesa.png 1x', type: 'image/png' }]" ratio="3:2")
      .column.is-widescreen-5.is-desktop-6
        .content.u-mb-xs
          div(v-html="$t('content')")
        AppLink(to="https://www.behance.net/gallery/75034935/Sellesa-Brand-Identity-Design" :title="$t('cta')" class="button-link  " v-html="$t('cta')")
        .u-mb-xs
        AppLink(to="https://www.behance.net/gallery/78348691/Sellesa-UIUX-Design" :title="$t('cta2')" class="button-link  " v-html="$t('cta2')")


  .u-mb-md

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Sellesa",
    "pageDesc":"Sellesa is an ecommerce software that is built to provide professional and easy store building experience.",
    "mantra":"Sellesa ecommerce |software.",
    "content":"<p>Building a store online is critical to business success. According to statistics, online shopping is gradually taking a larger portion of the whole purchase power globally. Without a strong presence online, store owners would be missing a great opportunity of expanding the reach of their business. But as business owners are always in a hurry and need to get things done faster, a simple solution was needed for building stores. </p><p>While software that already exist either too complex or too expensive, we aim to help businesses grow through providing high quality ecommerce solutions and give them confidence in their success even if they’re selling in space, that’s why we built Sellesa.</p><p>Sellesa is an ecommerce software that is professional and also easy to use, with all the features store owners may need but without any complexity in use and a customer support system that is always available to solve problems. The solution comes in affordable packages and suitable prices for all business types and sizes.</p><p>The solution will be launched by early 2020, but you can check the brand identity and website design and leave us your comments on Behance.</p>",
    "cta":"Brand identity",
    "cta2":"UX/UI design"
  },
  "ar": {
    "pageTitle":"سليسا",
    "pageDesc":"سليسا هو برنامج للتجارة الإلكترونية تم تصميمه لتمكين أصحاب الأعمال من بناء متاجرهم والوصول إلى عملائهم بطريقة أكثر ذكاءً.",
    "mantra":"سليسا برنامج |للتجارة الإلكترونية.",
    "content":"<p>بناء المتجر الإلكتروني يعتبر شيء بالغ الأهمية لنجاح الأعمال التجارية. وفقًا للإحصائيات فإن التسوق عبر الأنترنت أصبح يأخذ تدريجيًا جزءًا أكبر من إجمالي القوة الشرائية في العالم. بدون وجود قوي على الإنترنت، سيفقد أصحاب المتاجر فرصة كبيرة لتوسيع نطاق أعمالهم. ولكن نظرًا لأن أصحاب الأعمال في عجلة من أمرهم ويحتاجون لإنجاز الأمور بشكل أسرع، فقد كان هناك حاجة إلى حل بسيط لبناء المتاجر.</p><p>البرامج الموجودة حاليًا إما معقدة الاستخدام أو باهظة الثمن؛ لهذا نهدف إلى مساعدة الشركات على النمو من خلال توفير حلول عالية الجودة للتجارة الإلكترونية وفي نفس الوقت منحهم الثقة في نجاحها حتى لو كانوا يستهدفون عملاء من الفضاء، ومن هنا فكرنا في إنشاء سليسا. </p><p>سليسا هو برنامج للتجارة الإلكترونية سهل الاستخدام، ومع كل المميزات التي يحتاجها أصحاب المتاجر بدون أي تعقيد في الاستخدام كما أنه يوفر نظام دعم العملاء المتاح على الدوام لحل المشكلات. سليسا متوفر لديه العديد من الباقات بأسعار معقولة تتناسب مع جميع أنواع وأحجام الأعمال. </p><p>سوف يتم إطلاق سليسا بحلول أوائل 2020، لكن الآن يمكنك التحقق من تصميم هوية العلامة التجارية وكذلك تصميم الموقع على بيهانس.</p>",
    "cta":"تصميم العلامة التجارية",
    "cta2":"تصميم واجهة المستخدم / تجربة المستخدم"
  }
}
</i18n>
